import { ToastInfo, ToastSuccess } from '@/components/molecules/ToastTemplate/ToastTemplate';
import { dismissToast } from '@/components/molecules/ToastTemplate/toastStore';

const LUX_TOAST_ID = 'bioscope-lux-reply';

/**
 * The bioscope's answer to a lux command. A new answer replaces the open one, so an earlier
 * success never stays on screen over a later failure.
 */
export function showLuxReply(message: string, succeeded: boolean): void {
    dismissToast(LUX_TOAST_ID);
    if (succeeded) {
        ToastSuccess(message, LUX_TOAST_ID, { icon: 'lux' });
        return;
    }
    ToastInfo({
        content: message,
        status: 'error',
        icon: 'lux',
        options: { toastId: LUX_TOAST_ID, autoClose: 5000 },
    });
}
